import { defineStore } from "pinia";
export const useLayerStore = defineStore("layerStore", {
	state: () =>
		({
			layerChangeSets: {},
			layerStates: {},
			representationStates: {},
			layerCSV: {}
		}) as any,
	getters: {
		SSA_LAYER_STATES(): any {
			// [viewId][layerName]
			return this.layerStates;
		},
		SSA_REPRESENTATION_STATES(): any {
			// [viewId][layerName]
			return this.representationStates;
		},
		SSA_LAYER_CSV(): any {
			// [layerName]
			return this.layerCSV;
		},
		// ---- need to clean below -----
		SSA_LAYER_CHANGESETS(): any {
			// [viewId][layerName]
			return this.layerChangeSets;
		}
	},
	actions: {
		SSA_LAYER_CHANGESETS_SET({ layerName, changesets }: { layerName: any; changesets: any }) {
			this.layerChangeSets[layerName] = changesets;
		},
		SSA_LAYER_RESET() {
			this.layerChangeSets = {};
			this.layerStates = {};
			this.representationStates = {};
		},
		SSA_LAYER_RESET_VIEW(viewId: string | number) {
			let newState = Object.assign({}, this.layerChangeSets);
			delete newState[viewId];
			this.layerChangeSets = newState;

			newState = Object.assign({}, this.layerStates);
			delete newState[viewId];
			this.layerStates = newState;
		},
		SSA_LAYER_STATE_UPDATE(layerStates: any) {
			const newStates = Object.assign({}, this.layerStates);
			for (let i = 0; i < layerStates.length; i++) {
				const state = layerStates[i];
				const { name, view } = state;
				state.selection.names.sort();
				const newEntry = {
					[name]: state
				};
				if (!newStates[view]) {
					newStates[view] = newEntry;
				} else {
					newStates[view] = Object.assign({}, newStates[view], newEntry);
				}
			}
			this.layerStates = newStates;
		},
		SSA_REPRESENTATION_STATE_UPDATE(representationStates: any) {
			const newStates = Object.assign({}, this.representationStates);
			for (let i = 0; i < representationStates.length; i++) {
				const state = representationStates[i];
				if (!state) {
					continue;
				}
				const { layerName, view } = state;
				const newEntry = {
					[layerName]: state
				};
				if (!newStates[view]) {
					newStates[view] = newEntry;
				} else {
					newStates[view] = Object.assign({}, newStates[view], newEntry);
				}
			}
			this.representationStates = newStates;
		}
	},
	persist: false
});
